import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export const LOW_COUNT_THRESHOLD = 2

export class RecoveryCodesStatus {
  codesRemaining = 0
  totalCodes = 0
  generatedAt: Date | null = null

  isRunningLow(): boolean {
    if (this.totalCodes === 0) {
      return false
    }
    return this.codesRemaining <= LOW_COUNT_THRESHOLD
  }
}

export const RECOVERY_CODES_STATUS_DESER: SchemaDeSer<RecoveryCodesStatus> =
  new SchemaDeSerBuilder(RecoveryCodesStatus)
    .ofInt("codesRemaining")
    .ofInt("totalCodes")
    .ofDateTime("generatedAt")
    .toDeSer()
